import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BlogError } from '@/exceptions/blog/blog.enum';
import { blogService } from '@/services/blog.service';
import { notificationService } from '@/services/notification.service';

const useCreateBlog = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (blog: FormData) =>
            await blogService.newBlog(blog),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog'] });
            notificationService.success("blog Created Succesful");

        },

        onError: () => {
            throw new Error(BlogError.CREATE_ERROR);
        },
    });
};

export default useCreateBlog;
